var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconStarSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.683 1.875 15.82 8.09l6.038.598a.755.755 0 0 1 .468 1.288l-4.968 4.925 1.842 6.692a.761.761 0 0 1-1.08.876L12 19.44l-6.113 3.026a.762.762 0 0 1-1.079-.876l1.843-6.692-4.973-4.925a.755.755 0 0 1 .469-1.288l6.037-.598 3.133-6.211a.768.768 0 0 1 1.366 0"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M12.683 1.875 15.82 8.09l6.038.598a.755.755 0 0 1 .468 1.288l-4.968 4.925 1.842 6.692a.761.761 0 0 1-1.08.876L12 19.44l-6.113 3.026a.762.762 0 0 1-1.079-.876l1.843-6.692-4.973-4.925a.755.755 0 0 1 .469-1.288l6.037-.598 3.133-6.211a.768.768 0 0 1 1.366 0"
  }));
});
export default SvgIconStarSolid;
export const raw = __webpack_public_path__ + "static/media/IconStarSolid.0af8fb6e78c1117f13a299a6733aa711.svg";